<template>
  <div
    class="toggle-card-box card no-padding"
    :class="{ disabled: isDisabled }">
    <div
      class="toggle-card-header"
      @click="selected"
      :class="{ opened: isOpened }">
      <div class="info-box">
        <div class="title-holder">
          <LogosSVG :name="product.shipping_agent_name" size="62" class="m-r-20" />
          <div>
            <span class="sub-title m-b-5">{{ product.shipping_product_name}}</span>
            <span class="title b-block m-b-5">{{ `${ getPickupFromString }` }}</span>
            <span v-if="product.note" style="padding: 4px; margin-bottom: 4px; font-size: 13px; border-radius: 4px; background: #000; color: #fff">
            <Icon class="icon" fill-color="#fff" style="color: #fff; position:relative; top: 1px; display: inline-block" name="info" size="12"/>
            {{ product.note.trim() }}
          </span>
            <span class="sub-title">{{ getShipmentMustBeReadyString }}</span>
          </div>
        </div>
        <div>
        <span class="price-title">
          <span v-if="product.prices && product.total_price">{{ product.total_price | currency }}</span>
          <span v-else >-</span>
        </span>
        </div>
      </div>
      <div class="icon-holder">
        <Icon class="icon" v-show="!isOpened && !isDisabled"
              name="arrowRight"
              size="30" />
        <Icon class="icon" v-show="isOpened && !isDisabled"
              name="arrowDown"
              size="30" />
        <Icon class="icon color-warning" v-if="isDisabled"
              name="info"
              v-tooltip="{content: getErrorMsgTxt, class: 'pickup-popup-tooltip'}"
              size="26" />
      </div>
    </div>
    <div class="toggle-card-body" v-show="isOpened">
      <!-- ERROR -->
<!--      <div v-if="product.prices_error">-->
<!--        {{ product.prices_error.message }}-->
<!--      </div>-->
      <!-- PARCEL -->
      <div v-if="visibleBookingButton">
        <div>
          <div class="row m-b-20">
            <message
              v-if="showPickupTimeZoneMessage"
              style="margin-bottom: 25px" name="warning"
              :customIcon="'clock'"
              :data="data={data: getPickupTimeZoneMessage, type: 'custom-message'}">
            </message>
            <message
              v-if="showReadyToCloseTimeMessage"
              name="warning"
              style="margin-bottom: 25px"
              :customIcon="'clock'"
              :data="data={data: getReadyToCloseTimeMessage, type: 'custom-message'}">
            </message>
            <div class="col-xs-3 m-b-20">
              <InputSelect
                @change="returnHoursArrayFunction"
                ref="pickupTimeZone"
                :rules="{required: true}"
                :label="$t('timezone')"
                v-model="pickupTimeData.pickupTimeZone"
                :options="timeZones"/>
            </div>
            <div class="col-xs-5 m-b-20">
              <InputSelect
                ref="pickupFrom"
                :label="$t('ready_pickup_time')"
                v-model="pickupTimeData.pickupTimeFrom"
                :options="getTimeOptions.from" />
            </div>
            <div class="col-xs-4 m-b-20">
              <InputSelect
                ref="pickupUntil"
                :label="$t('latest_pickup_time')"
                v-model="pickupTimeData.pickupTimeUntil"
                :options="getTimeOptions.until" />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 m-b-20">
              <InputText
                :label="$t('Note to the driver')"
                v-model="pickupDriverNote" />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12" v-if="product.booked_pickup_id && pageType === 'view'"  style="margin-bottom: 25px">
              <InputSelect
                :label="$t('do_you_want_to_use_existing_booked_pickup')"
                v-model="shouldMoveShipmentsToExistingPickup"
                :options="[{text: 'yes', value: 1}, {'text': 'no', value: 0}]"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- SHIPMENT -->
      <h2 class="details-title">{{ $t('Price details') }}</h2>
      <div class="toogle-price-list opened">
        <!-- Title -->
        <div class="price-list">
          <div v-for="(priceItem, index) in product.prices" :key="`pricePDDt-${index}`">
            <span v-if="priceItem.type === 'vat'">{{ `${$t(priceItem.name)} (${user_vat_percent ? user_vat_percent : product.prices_data.vat_percent}%)`}}</span>
            <span v-else >{{`${$t(priceItem.name)}`}}</span>
            <span v-if="priceItem.sales_price != null">{{ priceItem.sales_price | currency }}</span>
            <span v-else>-</span>
          </div>
        </div>
        <div class="total-price" v-if="product.prices && product.total_price">
          <span class="total-price-title">{{ getTotalPriceText(product) }}</span>
          <span class="total-price-price">{{ product.total_price | currency }}</span>
        </div>
      </div>
      <message
        v-if="product.booked_pickup_id && pageType === 'index'"
        style="margin-bottom: 25px" name="warning"
        :customIcon="'truck'"
        :data="data={data: getPickupNotificationTxt, type: 'custom-message'}">
      </message>
      <!-- BOOKING -->
      <Btn
        v-if="visibleBookingButton"
        @btnClick="bookPickup"
        :loading="loadingButton"
        :disabled="disableButton"
        class="brand text-center m-b-20"
        :btnText="$t('book_pickup')"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';

import Btn from "@/components/elements/buttons";
import LogosSVG from "@/assets/images/logosSVG";
import PriceCard from "@/components/global/toggleCard/priceCard.vue";
import InputSelect from '@/components/elements/inputs/select.vue';
import InputText from '@/components/elements/inputs/text.vue';
import Popup from '@/components/global/popup';
import Checkbox from '@/components/elements/inputs/checkbox.vue';
import Calendar from '@/components/elements/inputs/calendar.vue';
import Toggle from "@/components/elements/inputs/toggle.vue";
import i18n from "@/i18n";
import dateMixin from "@/mixins/date";
import pickupTimeMixin from "@/mixins/pickupTime";

export default {
  name: 'ProductCard',
  components: {
    Btn,
    LogosSVG,
    PriceCard,
    Popup,
    Checkbox,
    InputSelect,
    InputText,
    Calendar,
    Toggle,
  },
  mixins: [dateMixin, pickupTimeMixin],
  props: {
    pickupLocationId: {
      type: [String, Number],
      default: '',
    },
    pageType: {
      type: [String],
      default: '',
    },
    pickupDate: {
      type: [String, Date],
      default: '',
    },
    showPrices: {
      type: [Boolean],
      default: false,
    },
    product: {
      type: Object,
      default: {},
    },
    isOpened: {
      type: Boolean,
      default: false,
    },
    disableButton: {
      type: Boolean,
      default: false,
    },
    loadingButton: {
      type: Boolean,
      default: false,
    },
    enabledProducts: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return{
      shouldMoveShipmentsToExistingPickup: 0,
      isOpenedPopup: false,
      pickupDriverNote: '',
      // Other
      APIerror: '',
    };
  },
  computed: {
    ...mapGetters([
      'get_booking_systems',
      'get_user',
      'get_active_subaccount',
      'get_currency',
      'get_pickup_location_by_id'
    ]),
    //new
    showPickupTimeZoneMessage() {
      const cond1 = this.pickupTimeData.pickupTimeZone !== this.getBrowserTimeZone;

      if (parseInt(this.product.id) === 0) {
        return false;
      }

      console.log(this.isPickupToday());
      if (this.isPickupToday()) {
        return cond1;
      }

      return false;
    },

    showReadyToCloseTimeMessage() {
      const cond1 = !!(
        this.product &&
        this.product.close_time &&
        this.product.ready_time);

      const cond2 =
        this.getTimeOptions.until &&
        this.getTimeOptions.until.length === 0;

      const cond3 =
        this.getTimeOptions.from &&
        this.getTimeOptions.from.length === 0;

      const baseCond = cond1 && (cond2 || cond3);

      return baseCond || !this.isPickupToday();
    },

    getReadyToCloseTimeMessage() {
      if (!this.product) return '';
      const closeTime = this.product.close_time;
      const readyTime = this.product.ready_time;
      if (!closeTime || !readyTime) return '';

      return i18n.tc('pickup_time_info_message', 2, {
        ready_time: readyTime,
        close_time: closeTime
      });
    },
    getNoProductsAvailableMessage() {
      return i18n.tc('no_valid_pickup_product_options_for_today_msg');
    },
    //end new
    getPickupNotificationTxt() {
      return `${this.$t('pickup_has_been_booked_on_this_address')} </br> ${this.$t('between')} ${this.product.ready_time} ${this.$t('and')} ${this.product.close_time}`;
    },
    getErrorMsgTxt() {
      let msg = '';

      if (this.product.goods_type_error) {
        msg = 'Unallowed goods type on shipment(s) with awb ' + this.product.goods_type_error.awbs.toString();
      }

      if (this.product.pickup_in_past_error) {
        msg = 'Pickup cannot be in past';
      }

      if (this.product.pickup_today_time_error) {
        msg = 'Current pickup time is not allowed. Book pickup for tomorrow';
      }

      if (this.product.product_error) {
        msg = 'Unallowed product on shipment(s) with awb ' + this.product.product_error.awbs.toString();
      }

      return msg;
    },
    visibleBookingButton() {
      return true;
    },
    getPickupFromString() {
      return i18n.t('book_pickup_at_latest_for_same_day', {call_time: this.product.call_time});
      //return `${this.$t('pickup_from')} ${this.product.ready_time} ${this.$t('to')} ${this.product.close_time}`;
    },
    getShipmentMustBeReadyString() {
      return ''; //`${this.$t('shipment_must_be_ready_latest_at')} ${this.product.ready_time}`;
    },
    isDisabled() {
      if(this.product.product_error
        || this.product.goods_type_error
        || this.product.pickup_in_past_error
        || this.product.pickup_today_time_error) {
        //Prices error should not disable product, only price will not be shown
        return true;
      } else {
        return false;
      }
    },
    getTimeOptions() {
      this.returnHoursArrayFunction(this.pickupTimeData.pickupTimeZone, this.isOpened)
      return this.returnHoursArray;
    },
    getPickupTimeZoneMessage() {
      return i18n.tc('pickup_time_and_zone_message', 2, {
        time: this.pickupTimeData.pickupTimeZoneCurrentTime,
        zone: this.pickupTimeData.pickupTimeZone
      })
    },
  },
  created() {
    if (this.get_booking_systems) {
      const systemSettings = this.get_booking_systems.items[0];
    }
    if (this.product.location_time_zone && this.product.location_time) {
      this.pickupTimeData.pickupTimeZoneCurrentTime = this.product.location_time;
      this.pickupTimeData.pickupTimeZone = this.product.location_time_zone;
      this.returnHoursArrayFunction(this.pickupTimeData.pickupTimeZone);
    }
  },
  methods: {
    getLocation() {
      if (!this.pickupLocationId || !this.pickupTimeData.pickupTimeZone) return null;
      return this.get_pickup_location_by_id(this.pickupLocationId);
    },
    getTotalPriceText(product) {
      return Number(product.prices?.vat_percent) ?  this.$t('total_incl_vat') : this.$t('total');
    },
    selectOptions(obj) {
      const options = [];
      for (const property in obj) {
        options.push({ text: obj[property], value: parseInt(property) });
      }
      return options;
    },
    selected() {
      if(this.isDisabled) return;
      this.$emit('selected', {
        product: this.product,
      });
    },
    bookPickup() {
      this.$emit('bookPickup', {
        should_move_shipments_to_existing_pickup: this.shouldMoveShipmentsToExistingPickup,
        pickup_driver_note: this.pickupDriverNote,
        pickup_time_from: this.pickupTimeData.pickupTimeFrom,
        pickup_time_until: this.pickupTimeData.pickupTimeUntil,
        pickup_time_zone: this.pickupTimeData.pickupTimeZone,
        product: this.product
      });
    },
    openPopup() {
      this.isOpenedPopup = true;
    },
    closePopup() {
      this.isOpenedPopup = false;
    },
    returnHoursArrayFunction(pickupTimeZone) {
      this.setBulkPickupTimeRange(this.product, pickupTimeZone, !this.isOpened);
    },
  },
}
</script>
